export const replaceIndonesianNumber = (phoneNumber) => {
  return phoneNumber ? phoneNumber.replace(/(^\+628|628|^08|^8)/g, '+628') : ''
}
